export type FilterCategoryType = 'colour' | 'range' | 'seatType' | "dimensions"

export interface MinMax {
  min: string
  max: string
}

export interface DimensionFilter extends MinMax {
  type: string
  subType: string
  title: string
}


export interface FiltersType {
  colour: ColourFilters
  range: RangeFilter[]
  seatType: SeatTypeFilter[]
  dimensions: DimensionFilter[]
}

export type FilterType = ColourFilter | RangeFilter | SeatTypeFilter | DimensionFilter

export interface SeatTypeFilter {
  id: string
  title: string
  type: string
}

export interface ColourFilters {
  [key: string]: {
    [key: string]: ColourFilter
  }
}

export interface ColourFilter {
  colourTitle: string
  id: number
  image: string
  title: string
  type: string
}

export interface RangeFilter {
  description: string
  id: number
  slug: string
  title: string
  type: string
}

export interface ActiveFilters {
  [key: string]: Set<string>
}

export interface ActiveDimensions {
  [key: string]: null | MinMax
}

export enum SortEnum {
  Recommended = 'recommended',
  SeatType = 'seatType',
  Range = 'range',
  Lowest = 'lowest',
  Highest = 'highest',
}
